// extracted by mini-css-extract-plugin
export var dropdownIcon = "_qs-6";
export var imgContainer = "_qs-3";
export var menuIcon = "_qs-5";
export var pillWrapper = "_qs-2";
export var pillsContainer = "_qs-1";
export var subscriptionCard = "_qs-0";
export var subscriptionLogo = "_qs-4";